import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Checkbox } from '../../../forms/atoms';
import type { BoolListOptionProps } from '../../layouts';
import { BoolListLayoutOption } from '../../layouts';

const checklistOptionStyle1 = css`
  margin-bottom: ${theme.spacing(2)};
`;

type Props = Omit<BoolListOptionProps<'checkbox'>, 'field'>;

export const CheckListOption = (props: Props) => {
  return <BoolListLayoutOption {...props} className={cx(checklistOptionStyle1, props.className)} field={Checkbox} />;
};
